import { motion } from "framer-motion";
import { Feather } from "lucide-react";
import { CHECKOUT_URL, PRICE_DISCOUNTED } from "@/lib/constants";
import { CountdownTimer } from "./CountdownTimer";

export const StickyHeader = () => (
  <motion.header
    data-testid="sticky-header"
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed top-0 left-0 right-0 z-50 border-b border-[#d4af37]/15 bg-[#08080a]/70 backdrop-blur-xl"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <a href="#topo" data-testid="header-brand" className="flex items-center gap-2.5">
        <Feather className="w-4 h-4 text-[#d4af37]" strokeWidth={1.5} />
        <span className="font-serif text-xl tracking-[0.28em] text-[#f4f1ea]">ESTÓICO</span>
      </a>
      <div className="flex items-center gap-5">
        <CountdownTimer variant="compact" />
        <a
          data-testid="header-buy-button"
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gold-gradient text-[#08080a] text-xs sm:text-sm font-bold tracking-wide px-5 py-2.5 rounded-full transition-transform duration-300 hover:scale-105"
        >
          Garantir por {PRICE_DISCOUNTED}
        </a>
      </div>
    </div>
  </motion.header>
);
